import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { EmpresaService } from 'src/app/services/empresa.service';


@Component({
  selector: 'app-distribuidor-form',
  templateUrl: './distribuidor-form.component.html',
  styleUrls: ['./distribuidor-form.component.scss'],
  providers: [MessageService]
})
export class DistribuidorFormComponent implements OnInit {
  form!: FormGroup;
  submitted = false;


  constructor(private fb: FormBuilder, private auth: AuthService, private rutaActiva: ActivatedRoute, private router: Router, private empresaService: EmpresaService, private messageService: MessageService) {
    //let producto_id: number = this.rutaActiva.snapshot.params['id'];
    let usuario = this.auth.Session?.id
  }
  load(id: number): void {

  }
  ngOnInit(): void {
    this.form = this.createFormulario();
  }

  // getters para facilitar validación en template
  get f() { return this.form.controls; }

  getControl(name: string): AbstractControl {
    return this.form.get(name)!;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.showWarning('Formulario inválido, valida tu información');
      return;
    }
    // aquí iría la llamada a tu servicio para guardar...
    console.log('Payload:', this.form.getRawValue());
    if (this.auth.Session?.id) this.empresaService
      .updateEmpresa(this.form.getRawValue(), this.auth.Session?.id)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.auth.setNewSession(resp.datos);
          console.log(resp.datos)
        }, error: (err) => {
          this.showError('Error: verifica tu información ')
          console.error(err)
        }
      })

  }

  createFormulario(): FormGroup {
    return this.fb.group({
      id: [{ value: this.auth.Session?.id, disabled: true }],
      email: [{ value: this.auth.Session?.email, disabled: true }, [Validators.email, Validators.maxLength(255)]],
      rfc: [this.auth.Session?.rfc, [Validators.required, Validators.maxLength(16), Validators.pattern(/^([A-ZÑ&]{3,4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[A-Z\d]{3}$/i)]],
      nombre: [this.auth.Session?.nombre, [Validators.required, Validators.maxLength(100)]],
      codigo_postal: [this.auth.Session?.codigo_postal, [Validators.required, Validators.pattern(/^\d{5}$/)]],
      entidad_federativa: [this.auth.Session?.entidad_federativa, [Validators.required, Validators.maxLength(150)]],
      nombre_contacto: [this.auth.Session?.nombre_contacto, [Validators.required, Validators.maxLength(200)]],
      telefono: [this.auth.Session?.telefono, [Validators.required, Validators.pattern(/^\d{10}$/)]]
    });

  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
  showError(msg: string): void {
    this.messageService.add({ severity: 'error', summary: 'Fallo!!', detail: msg });
  }
  showInfo(msg: string): void {
    this.messageService.add({ severity: 'info', summary: 'Fallo!!', detail: msg });
  }
  salir(): void {
    this.router.navigate(['/facturas'])
  }
}
